module.exports = __webpack_public_path__ + "img/小手.b8cbd97d.png";